import { useTranslation } from 'react-i18next';
import { Domain as DomainEnum } from '@tiendanube/common/src/enums';
import { Card, Text } from '@tiendanube/components';

function CardPaymentSkeleton(): JSX.Element {
  const { t } = useTranslation([DomainEnum.ORDERS]);

  return (
    <Card title={t('cardPayment.title')} headerLabel="skeleton">
      <Text.Skeleton width="large" />
    </Card>
  );
}

export default CardPaymentSkeleton;
